export default __webpack_public_path__ + "static/media/icon-pathway-bbp.33615bcd.png";